import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import UserService from '../Services/UserService.js';
import { withApi } from '../Providers/WebServiceProvider.js';

class UserProfileButton extends Component
{
	state = {
		modal: this.props.forceModal ? this.props.forceModal : false,
		firstname: this.props.webServiceContext.auth.getUser().getFirstname() ? this.props.webServiceContext.auth.getUser().getFirstname() : "",
		lastname: this.props.webServiceContext.auth.getUser().getLastname()  ? this.props.webServiceContext.auth.getUser().getLastname() : "",
		currentPassword: "",
		password: "",
		passwordConfirmation: "",
		errors: {},
		isSaving: false,
		saved: false
	}

	constructor (props) {
		super(props);

		this.form = React.createRef();
		this.canBeSaved = this.canBeSaved.bind(this);
		this.userService = new UserService(this.props.webServiceContext.getApi());
		this.updateAttributes = this.updateAttributes.bind(this);
	}

	inputClass (input) {
		if (input in this.state.errors) {
			return "input is-danger";
		} else {
			return "input"
		}
	}

	showErrors (field) {
		if (this.state.errors[field]) {
			return (
				<span className="help is-danger">{this.state.errors[field]}</span>
			);
		} else {
			return null;
		}
	}

	canBeSaved () {
		if (this.props.forceModal) {
			return (this.state.firstname !== "" && this.state.lastname !== "");
		} else {
			if (this.state.password) {
				return (this.state.currentPassword !== "" && this.state.passwordConfirmation !== "");
			} else {
				return true;
			}
		}
	}

	buildRequestData () {
		let data = {
			firstname: this.state.firstname,
			lastname: this.state.lastname
		};

		if (this.state.password) {
			data.current_password = this.state.currentPassword;
			data.password = this.state.password;
			data.password_confirmation = this.state.passwordConfirmation;
		}

		return data;
	}

	updateAttributes (e) {
		const that = this;

		e.preventDefault();

		this.setState({ isSaving: true });

		const wasModalPreviouslyForced = this.props.forceModal;

		return new Promise((resolve, reject) => {
			const updated = that.userService.updateMany(that.props.webServiceContext.auth.getUser(), that.buildRequestData());
			if (updated) {
				updated.then(function (response) {
						that.props.webServiceContext.auth.updateUserProperties(response.data.data.user);

						that.setState((prevState) => ({
        			isSaving: false,
        			saved: (wasModalPreviouslyForced) ? false : true,
        			currentPassword: "",
							password: "",
							passwordConfirmation: "",
							errors: {},
							modal: (wasModalPreviouslyForced) ? false : true
        		}), function () {
        			if (!wasModalPreviouslyForced) {
	        			setTimeout(function () {
	        				that.setState({ saved: false });
	        			}, 3000)
        			}
        		});
					})
					.catch(function (response) {
						if ('response' in response && 'data' in response.response) {
							const data = response.response.data;
							if (data.errors) {
								that.setState({ errors: data.errors, isSaving: false });
							} else {
								throw response;
							}
						} else {
							throw response;
						}
					})
			}
    });
	}

	render () {
		const profileName = this.props.webServiceContext.auth.getUser().getFirstname() 
			? this.props.webServiceContext.auth.getUser().getFirstname() 
			: this.props.webServiceContext.auth.getUser().getEmail();

		return (
			<Fragment>
				<div className="user-profile" onClick={() => this.setState({ modal: true }) }>
					<span className="icon-container">
						<FontAwesomeIcon icon="user" className="icon" /> 
					</span>
					<span className="user-container">
						{profileName}
					</span>
				</div>
		 	  <div className={(this.state.modal) ? 'modal is-active' : 'modal'}>
		 	  	<div className="modal-background"></div>
		 	  	<div className="modal-content">
		 	  		<div className="page-section">
		 	  			<div className="title">
		 	  				<span className="title-content"> 
			 	  				Edit User Settings
			 	  				{
				 	  				this.props.forceModal && (
											<div className="sub-title">
											 You must fill in your firstname and lastname before you can use Tovertaal.
						 	  			</div>
				 	  				)
				 	  			}
				 	  		</span>
		 	  			</div>
		 	  			<form ref={this.form} key="profile.settings">
			 	  			<div className="content">
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input
									        	required={this.props.forceModal}
									        	className={this.inputClass('firstname')}
									        	type="text" 
									        	placeholder="Firstname" 
									        	onChange={(e) => this.setState({ firstname: e.target.value }) } 
									        	value={this.state.firstname}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="user" />
									        </span>
									        {this.showErrors('firstname')}
									      </p>
					      			</div>
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	required={this.props.forceModal}
									        	className={this.inputClass('lastname')}
									        	type="text" 
									        	placeholder="Lastname (optional)" 
									        	onChange={(e) => this.setState({ lastname: e.target.value }) } 
									        	value={this.state.lastname}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="user" />
									        </span>
									        {this.showErrors('lastname')}
									      </p>
					      			</div>
					      		</div>
					      	</div>
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	readOnly 
									        	className="input" 
									        	type="email is-static" 
									        	placeholder="E-Mail Address"  
									        	defaultValue={this.props.webServiceContext.auth.getUser().getEmail()}
									        />
									        <span className="icon is-small is-left">
									          <FontAwesomeIcon icon="envelope" />
									        </span>
									      </p>
					      			</div>
					      		</div>
					      	</div>
					      	<hr/>
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	className={this.inputClass('currentPassword')}
									        	type="password" 
									        	placeholder="Current Password" 
									        	onChange={(e) => this.setState({ currentPassword: e.target.value }) } 
									        	value={this.state.currentPassword}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="key" />
									        </span>
									        {this.showErrors('current_password')}
									      </p>
					      			</div>
					      		</div>
					      	</div>
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	className={this.inputClass('password')}
									        	type="password" 
									        	placeholder="New Password" 
									        	onChange={(e) => this.setState({ password: e.target.value }) } 
									        	value={this.state.password}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="key" />
									        </span>
									        {this.showErrors('password')}
									      </p>
					      			</div>
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	className="input {this.inputClass('passwordConfirmation')}" 
									        	type="password" 
									        	placeholder="Verify New Password" 
									        	onChange={(e) => this.setState({ passwordConfirmation: e.target.value }) } 
									        	value={this.state.passwordConfirmation}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="key" />
									        </span>
									        {this.showErrors('passwordConfirmation')}
									      </p>
					      			</div>
					      		</div>
					      	</div>
			 	  			</div>
			 	  			<div className="bottom">
						      <div className="level">
						        <div className="level-left">
						        	{ !this.props.forceModal && (<button 
						        		type="button"
						        		className="button is-primary is-outlined" 
						        		onClick={() => this.setState({
						        			modal: false,
						        			errors: {},
						        			isSaving: false,
						        			saved: false
						        		}) }
						        	>Cancel</button>) }
						        </div>
						        <div className="level-right">
						          <span className="level-item">
						            <button
						            	disabled={this.state.isSaving || !this.canBeSaved()} 
						            	onClick={this.updateAttributes}
						            	className={
						            		this.state.isSaving 
						            			? 'button is-primary is-gradient can-be-saved is-loading' 
						            			: (this.state.saved)
						            				? 'button is-primary is-gradient can-be-saved is-saved'
						            				: 'button is-primary is-gradient can-be-saved'
						            	}
						            >
						            </button>
						          </span>
						        </div>
						      </div>
			 	  			</div>
		 	  			</form>
		 	  		</div>
		 	  	</div>
		 	  </div>
			</Fragment>
		);
	}
}

export default withApi(UserProfileButton);


// WEBPACK FOOTER //
// ./src/Components/UserProfileButton.js